import * as React from 'react';
import * as Utils from '../Utils';

export interface IClockAccuracyReportProps {
  offsetSec?: number;
}

export function ClockAccuracyReport(props: IClockAccuracyReportProps) {
  if (props.offsetSec === undefined) {
    return null;
  }
  if (Math.abs(props.offsetSec) <= 1) {
    return (
      <small>
        Your clock is accurate ✅
      </small>
    );
  }
  return (
    <small>
      Your clock is {Utils.getLabel(Math.abs(props.offsetSec*1000))} {props.offsetSec < 0 ? "late" : "fast"} ⭕
    </small>
  );
}



// WEBPACK FOOTER //
// ./src/Timer/ClockAccuracyReport.tsx